import { SxProps } from '@mui/material'

interface PhoneNumberCountryDropdownStyles {
  button: SxProps
  popper: SxProps
  dropdownWrapper: SxProps
  inputWrapper: SxProps
}

export const phoneNumberCountryDropdownStyles: PhoneNumberCountryDropdownStyles = {
  button: {
    p: 0,
    m: 0,
    minWidth: 'auto',
    color: 'inherit',
    font: 'inherit',
  },
  popper: {
    my: '5px !important',
  },
  dropdownWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  inputWrapper: {
    p: 0.2,
  },
}
